module.exports = __webpack_public_path__ + "img/chat.8a618932.gif";